import Buttons from "../../../components/UI/Buttons";

const InsurancePolicies = (props) => {
    return (
        <>
            <div class="col-md-6 col-12 mb-2 pb-1">
                <div class="card mb-0 border-0">
                    <a class="card-header sh_accordionheader" data-bs-toggle="collapse" href="#insurancepolicies" role="button" aria-expanded="true" aria-controls="missingClaimsDetails">Insurance Policies</a>
                    <div class="collapse show" id="insurancepolicies">
                        <div class="card-body p-2">
                            <div class="row">
                                <div class="col-md-6 col-12 mb-2">
                                    <label class="f-400 text-sm p2-light text-truncate mb-1">Primary Carrier</label>
                                    <h6 class="font-weight-bold text-sm text-truncate mb-0" title="TravelerInsurance">Traveler's Insurance</h6>
                                </div>
                                <div class="col-md-6 col-12 mb-2">
                                    <label class="f-400 text-sm p2-light text-truncate mb-1">Policy Number</label>
                                    <h6 class="font-weight-bold text-sm text-truncate mb-0" title="">TRV-2024-001234</h6>
                                </div>
                                <div class="col-md-6 col-12 mb-2">
                                    <label class="f-400 text-sm p2-light text-truncate mb-1">Coverage Period</label>
                                    <h6 class="font-weight-bold text-sm text-truncate mb-0" title="">Jan 1, 2024 - Dec 31, 2024</h6>
                                </div>
                                <div class="col-md-6 col-12 mb-2">
                                    <label class="f-400 text-sm p2-light text-truncate mb-1">Deductible</label>
                                    <h6 class="font-weight-bold text-sm text-truncate mb-0" title="TravelerInsurance">$2,500</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default InsurancePolicies;